// Ylläpidon "Lisää kohde tähän" -lomakkeen logiikka (components/PoiCreateSheet.jsx).
// Kohteen piste otetaan GPS:stä paikan päällä; palvelin (backend/app/route_admin.py, POST /api/admin/pois)
// kirjoittaa kohteen lisäpakettiin. Tämä tiedosto päättää, mitä lomake hyväksyy ja mitä se lähettää.
// Puhtaita funktioita, jotta ne on helppo testata.

export const CATEGORY_LABELS = {
  luonto: "Luonto",
  historia: "Historia",
  arkkitehtuuri: "Arkkitehtuuri",
  nakoala: "Näköala",
  taukopaikka: "Taukopaikka",
  muu: "Muu",
};

/** Tunnistusalueen valinnat (m), samat kuin pisteen asetuksessa. */
export const POI_RADII = [25, 40, 60, 100, 200];

/** Tyhjä lomake. Tunnistusalue 40 m on palvelimenkin oletus. */
export const EMPTY_POI_FORM = { name: "", municipality: "", area: "", category: "", description: "", note: "", radius: 40 };

/** Luokat valintalistaan: sisällössä jo olevat (palvelin hyväksyy vain ne), tunnetut nimillä, aakkosjärjestyksessä. */
export function categoryOptions(content) {
  const ids = [...new Set((content?.pois ?? []).map((p) => p.category).filter(Boolean))];
  return ids.map((id) => ({ id, label: CATEGORY_LABELS[id] ?? id })).sort((a, b) => a.label.localeCompare(b.label, "fi"));
}

/** Kunnat ehdotuksiksi: kohteilla ja reiteillä jo olevat, aakkosjärjestyksessä. */
export function poiMunicipalities(content) {
  const all = [...(content?.pois ?? []), ...(content?.routes ?? [])].map((x) => x.municipality).filter(Boolean);
  return [...new Set(all)].sort((a, b) => a.localeCompare(b, "fi"));
}

/** Lomakkeen virheet suomeksi. `fix` = GPS-haun tulos { lat, lon, accuracy } tai null. Tyhjä lista = voi tallentaa. */
export function poiFormErrors(form, fix) {
  const errors = [];
  if (!fix) errors.push("Hae ensin sijaintisi painamalla \"Käytä sijaintiani\". Piste otetaan GPS:stä.");
  else if (fix.stale) errors.push("Sijainti on vanha. Hae sijainti uudelleen paikan päällä, jotta piste on maastotarkistettu.");
  if (!form.name?.trim()) errors.push("Anna kohteelle nimi.");
  if (!form.municipality?.trim()) errors.push("Anna kunta.");
  if (!form.category) errors.push("Valitse kohteen tyyppi.");
  return errors;
}

/** Palvelimelle lähetettävä runko. Tyhjät valinnaiset kentät jätetään pois. GPS:llä haettu piste on maastotarkistettu. */
export function poiPayload(form, fix) {
  const body = {
    name: form.name.trim(),
    municipality: form.municipality.trim(),
    category: form.category,
    lat: fix.lat,
    lon: fix.lon,
    visit_radius_m: form.radius,
    verification: "field_checked",
  };
  for (const key of ["area", "description", "note"]) {
    const v = form[key]?.trim();
    if (v) body[key] = v;
  }
  return body;
}

/** Tallennuksen jälkeinen viesti { what, sub } ilmoitukseen. */
export function poiSavedMessage(result, name) {
  return { what: "Kohde lisätty", sub: `${name}: ${result.points ?? "?"} pistettä ensikäynnistä, tunnistuu kun kuljet paikalle.` };
}
